import { IAccount, IXeroTaxRate } from '../models/xero';

export const formatTaxRateButtonContent = (
    allTaxRates: IXeroTaxRate[],
    currentXeroTaxType: string | undefined | null,
    placeholderText: string
) => {
    const taxRate = allTaxRates.find((x) => x.taxType === currentXeroTaxType);
    return taxRate ? <>{taxRate.name}</> : <>{placeholderText}</>;
};

export const formatTaxRateListItem = (taxRate: IXeroTaxRate): JSX.Element => {
    return (
        <div className='xui-margin-left-xsmall xui-margin-top-small'>
            <div>{taxRate.name}</div>
        </div>
    );
};

export const validateTaxRateAndAccount = (account: IAccount, taxRate: IXeroTaxRate) : boolean => {
    let isValid = true;

    switch (account.class.toUpperCase()) {
        case 'ASSET':
            isValid = taxRate.canApplyToAssets;
            break;
        case 'EQUITY':
            isValid = taxRate.canApplyToEquity;
            break;
        case 'EXPENSE':
            isValid = taxRate.canApplyToExpenses;
            break;
        case 'LIABILITY':
            isValid = taxRate.canApplyToLiabilities;
            break;
        case 'REVENUE':
            isValid = taxRate.canApplyToRevenue;
            break;
    }

    return isValid;
};
